import productGroupFields from "./productGroupFields";
import pageBuilderFields from "./pageBuilderFields";
import { applyFrench } from "@lib/applyFrenchField";

const internalLink = `
  _type == "internalLink" => {
    "type": @->_type,
    "slug": @->slug,
    "handle": @->store.slug.current,
    "id": @->_id,
    "productGroup": *[_type == "product" && ^->_id == _id] {
      "data": *[_type=='productPage' && references(^._id) ] {
        ${productGroupFields}
      }
    }[0],
  }
`;

const text = `${applyFrench(
  `text[] {
      ...,
      markDefs[]{ ..., ${internalLink}}
  }`,
  `text_fr.portableText[] {
      ...,
      markDefs[]{ ..., ${internalLink}}
  }`
)}`;

const blocksFields = `
  blocks[] {
    ...,
    "title": ${applyFrench("title", "title_fr")},
    "subTitle": ${applyFrench("subTitle", "subTitle_fr")},
    "heading": ${applyFrench("heading", "heading_fr")},
    "subHeading": ${applyFrench("subHeading", "subHeading_fr")},
    "buttonLabel": ${applyFrench("buttonLabel", "buttonLabel_fr")},
    store[]->{
      'key': _id,
      city,
      slug
    },
    editorials[] -> {
      ...,
      "key": _id
    },
    navigationLinks[] {
      ...,
      'key': _key,
      "title": ${applyFrench("title", "title_fr")},
      'refTitle': link.document->title,
      'type': link.document->_type,
      'link': link.link,
      'handle': link.document->store.slug.current,
      'slug': link.document->slug,
      "productGroup": *[_type=='productPage' && references(^.link.document->_id) ] {
        ${productGroupFields}
      }
    },
    "text": ${text},
    productsV2[] -> {
      ...,
      "productPage": *[_type=='productPage' && references(^._id) ] {
        ${productGroupFields}
      }[0]
    },
    items[] {
      ...,
      "title": ${applyFrench("title", "title_fr")},
      collection->
    },
    "itemsCountSmall": (count(spreadItems[]) - count(spreadItems[hide match 'S'])),
    "itemsCountMedium": (count(spreadItems[]) - count(spreadItems[hide match 'M'])),
    "itemsCountLarge": (count(spreadItems[]) - count(spreadItems[hide match 'L'])),
    spreadItems[] {
      ...,
      cta {
        "title": ${applyFrench("title", "title_fr")},
        'refTitle': document->title,
        'type': document->_type,
        link,
        'handle': document->store.slug.current,
        'slug': document->slug,
        "productGroup": *[_type=='productPage' && references(^.document->_id) ] {
          ${productGroupFields}
        },
      },
      text {
        "text": ${text}
      },
      videoSrc {
        ...,
        asset->{
          ...,
          "url": "https://stream.mux.com/" + playbackId
        }
      },
    },
    ctas[] {
      'key': _key,
      "title": ${applyFrench("title", "title_fr")},
      'refTitle': link.document->title,
      'type': link.document->_type,
      'link': link.link,
      'handle': link.document->store.slug.current,
      'slug': link.document->slug,
      'id': link.document->_id,
      "productGroup": *[_type=='productPage' && references(^.link.document->_id) ] {
        ${productGroupFields}
      },
    },
    cta {
      "title": ${applyFrench("title", "title_fr")},
      'refTitle': link.document->title,
      'type': link.document->_type,
      'link': link.link,
      'handle': link.document->store.slug.current,
      'slug': link.document->slug,
      "productGroup": *[_type=='productPage' && references(^.link.document->_id) ] {
        ${productGroupFields}
      },
    },
    ${pageBuilderFields}
},
`;

export default blocksFields;
